<template>
  <div class="expend-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>费项科目</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入费项科目" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>收费类型</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.type" class="app-block" placeholder="请选择收费类型">
              <a-select-option :value="value.id" v-for="value in typeOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8" v-if="isPlatformRole">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>发布社区</p>
          </a-col>
          <a-col>
            <a-select v-model="table.search.community" class="app-block" placeholder="请选择发布社区">
              <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-row class="mg-normal">
      <a-col>
        <a-space>
          <a-button type="primary" @click="newExpend()">新增费项</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <template v-if="(!isPlatformRole && data.generate_source === 'platform') || (isPlatformRole && data.generate_source === 'community')"></template>
          <template v-else>
            <a-button type="link" @click="editExpend(data)">编辑</a-button>
            <a-button type="link" @click="deleteExpend(data)" v-if="!data.is_default">删除</a-button>
          </template>
        </a-space>
      </template>
    </a-table>
  </div>
</template>

<script>
  import {
    paymentCycleStatusText
  } from '@/io/dict.js';
  import CommunityService from '@/io/community.js';
  import ChargeTypeService from '@/io/charge_type.js';
  import ExpendService from '@/io/expend.js';

  export default {
    name: 'ExpendManage',
    data() {
      let self = this;
      return {
        paymentCycleStatusText,
        table: {
          loading: false,
          search: {
            name: null,
            type: [],
            community: []
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            }
          },
          data: [],
          columns: [
            {
              title: '费项科目',
              dataIndex: 'name'
            },
            {
              title: '收费类型',
              dataIndex: 'expenses_type_name'
            },
            {
              title: '计费周期',
              dataIndex: 'paymentCycleStatusText'
            },
            {
              title: '滞纳金',
              dataIndex: 'lateFeeText'
            },
            {
              title: '来源',
              dataIndex: 'sourceText'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        communityOptions: [],
        typeOptions: [],
      }
    },
    activated () {
      Promise.all([
        this.initCommunity(),
        this.initType()
      ]).then(() => {
        this.initData();
      });
    },
    methods: {
      newExpend() {
        this.table.page.current = 1;
        this.$router.push({
          name: 'NewExpend'
        });
      },
      editExpend(data) {
        this.$router.push({
          name: 'EditExpend',
          params: {
            id: data.id
          }
        });
      },
      deleteExpend(data) {
        let self = this;
        this.$confirm({
          title: '提示',
          content: '确认删除此费项？',
          onOk() {
            ExpendService.del(data.id).then(res => {
              self.initData();
            }).catch(err => {});
          }
        });
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null,
          type: [],
          community: []
        };
        this.searchTable();
      },
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.communityOptions = res;
        }).catch(err => {});
      },
      initType() {
        return ChargeTypeService.list().then(res => {
          this.typeOptions = res;
        }).catch(err => {});
      },
      initData() {
        this.table.loading = true;
        ExpendService.listPage(
          this.table.search.name,
          this.table.search.type,
          this.table.search.community,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            if (val.generate_source === 'platform') {
              val.sourceText = '平台';
            } else {
              this.communityOptions.forEach(m => {
                if (m.id === val.community_id) {
                  val.sourceText = m.name;
                }
              });
            }
            val.lateFeeText = val.has_late_fee ? '有' : '没有';
            val.paymentCycleStatusText = paymentCycleStatusText(val.billing_cycle_type);
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>